import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const DollarSignCardIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M7 16H8C8 16.2833 8.096 16.521 8.288 16.713C8.48 16.905 8.71734 17.0007 9 17C9.28334 17 9.521 16.904 9.713 16.712C9.905 16.52 10.0007 16.2827 10 16H11C11.2833 16 11.521 15.904 11.713 15.712C11.905 15.52 12.0007 15.2827 12 15V12C12 11.7167 11.904 11.479 11.712 11.287C11.52 11.095 11.2827 10.9993 11 11H8V10H11.025C11.3083 10 11.5417 9.904 11.725 9.712C11.9083 9.52 12 9.28267 12 9C12 8.71667 11.904 8.479 11.712 8.287C11.52 8.095 11.2827 7.99934 11 8H10C10 7.71667 9.904 7.479 9.712 7.287C9.52 7.095 9.28267 6.99934 9 7C8.71667 7 8.479 7.096 8.287 7.288C8.095 7.48 7.99934 7.71734 8 8H7C6.71667 8 6.479 8.096 6.287 8.288C6.095 8.48 5.99934 8.71734 6 9V12C6 12.2833 6.096 12.521 6.288 12.713C6.48 12.905 6.71734 13.0007 7 13H10V14H6.975C6.69167 14 6.45834 14.096 6.275 14.288C6.09167 14.48 6 14.7173 6 15C6 15.2833 6.096 15.521 6.288 15.713C6.48 15.905 6.71734 16.0007 7 16ZM15.65 15.9C15.75 16 15.8667 16.05 16 16.05C16.1333 16.05 16.25 16 16.35 15.9L18 14.25H14L15.65 15.9ZM14 10H18L16.35 8.35C16.25 8.25 16.1333 8.2 16 8.2C15.8667 8.2 15.75 8.25 15.65 8.35L14 10ZM4 20C3.45 20 2.979 19.804 2.587 19.412C2.195 19.02 1.99934 18.5493 2 18V6C2 5.45 2.196 4.979 2.588 4.587C2.98 4.195 3.45067 3.99934 4 4H20C20.55 4 21.021 4.196 21.413 4.588C21.805 4.98 22.0007 5.45067 22 6V18C22 18.55 21.804 19.021 21.412 19.413C21.02 19.805 20.5493 20.0007 20 20H4ZM4 18H20V6H4V18Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
